import React, { FC, useMemo } from 'react';
import { Dropdown, useScopedSelector } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import { isNullOrWhitespaces } from 'omni-package-react-core';
import transformSubjects from './transformSubjects';
import { SubjectDto } from '../../../../../../interfaces/dtos/SubjectDto';
import getApiRoot from '../../../../../../utils/getApiRoot';
import SubjectsControl from './SubjectsControl';
import { NewMessagePageState } from '../../../../../../interfaces/NewMessagePageState';
import DropdownLoader from '../../../../../../components/_DropdownLoader';

export interface SubjectsLoaderProps { }

const SubjectsLoader: FC<SubjectsLoaderProps> = () => {
  const { t } = useTranslation('NewMessagePage');
  const mail = useScopedSelector((state: NewMessagePageState) => state.mailFormValues);
  const isExcludedContract = !isNullOrWhitespaces(mail?.contract?.systemExclusionMessage);
  const selectedObject = mail?.subjectGroup;
  const url = useMemo(() => `${getApiRoot()}/settings/subjects?subjectGroupId=${selectedObject}`, [selectedObject]);
  return (
    selectedObject ?
      (
        <DropdownLoader
          name="/App.features.messages.new.subjectsResource"
          url={url}
          dataDst="subjects"
          autoRequest
          requestOnLanguageChange
          transformResponse={({ data }: { data: SubjectDto[] }) => transformSubjects(data)}
        >
          <SubjectsControl disabled={isExcludedContract} />
        </DropdownLoader>
      ) : <Dropdown disabled aria-label={t('disabled')} />
  );
};
export default SubjectsLoader;
